import { useContext } from 'react';
import { AddManageUsersContext } from '../contexts/add-manage-users-context';
export var useAddManageUsers = function () {
    var context = useContext(AddManageUsersContext);
    if (!context) {
        throw new Error('useAddManageUsers must be used within AddManageUsersProvider');
    }
    return context;
};
